var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeprecatedMapPin = function SvgDeprecatedMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.997 7.815A8.687 8.687 0 0 0 13.55.118a9.347 9.347 0 0 0-7.548 2.12 8.467 8.467 0 0 0-2.999 6.397 6.998 6.998 0 0 0 1.23 3.939l6.937 9.996A1 1 0 0 0 12 23a1 1 0 0 0 .83-.45l6.398-9.456a7.538 7.538 0 0 0 1.769-5.279Zm-12.496-.56 1.24-1.249a.92.92 0 0 1 .63-.24.85.85 0 0 1 .63.24l.999 1 1-1a.85.85 0 0 1 .62-.26.89.89 0 0 1 .63.26l1.249 1.27a.88.88 0 0 1 0 1.25L12 12.003 8.501 8.505a.88.88 0 0 1 0-1.25Z",
    fill: "#262626"
  })));
};
export default SvgDeprecatedMapPin;